/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Compat_3Inputs */

const en_pc_online_compat_3 = /** @type {(inputs: Pc_Online_Compat_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy and paste needs a secure (HTTPS) page, which this one is.`)
};

const zh_pc_online_compat_3 = /** @type {(inputs: Pc_Online_Compat_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制粘贴需要安全（HTTPS）页面，本页满足这一条件。`)
};

/**
* | output |
* | --- |
* | "Copy and paste needs a secure (HTTPS) page, which this one is." |
*
* @param {Pc_Online_Compat_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_compat_3 = /** @type {((inputs?: Pc_Online_Compat_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Compat_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_compat_3(inputs)
	return zh_pc_online_compat_3(inputs)
});
export { pc_online_compat_3 as "pc.online.compat.3" }